import { createContext, use } from "react";

import { noop } from "@bokio/shared/utils";

import type { UmbracoReleaseNoteModel } from "@bokio/shared/models/UmbracoReleaseNotesModel";

export type ReleaseNotesContextValue = {
	whatsNewData: UmbracoReleaseNoteModel[];
	hasNewNotesCompany: boolean;
	hasNewNotesAgency: boolean;
	setLastReadPrefernce: () => void;
	noOfUpdates: number;
};
export type ReleaseNoteType = "Agency" | "Company";

export const ReleaseNotesContext = createContext<ReleaseNotesContextValue>({
	whatsNewData: [],
	hasNewNotesCompany: false,
	hasNewNotesAgency: false,
	setLastReadPrefernce: noop,
	noOfUpdates: 0,
});

export const useReleaseNotesContext = () => use(ReleaseNotesContext);
